import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

// Функция для определения системной темы
const getSystemTheme = () => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }
  return 'dark' // fallback
}

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: getSystemTheme(), // Используем системную тему по умолчанию
    themes: {
      light: {
        colors: {
          primary: '#3F51B5',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          black: '#000000',
        }
      },
      dark: {
        colors: {
          primary: '#536DFE',
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          black: '#000000',
        }
      }
    }
  },
  // Настройки для Montserrat шрифта
  defaults: {
    global: {
      fontFamily: "'Montserrat', sans-serif"
    },
    VCard: {
      class: 'rounded-lg'
    },
    VBtn: {
      class: 'text-none'
    }
  }
})

export default vuetify